<template>
  <div
    class="error-tooltip-container hidden-visibility"
    ref="tooltip"
    @mouseenter="showTooltip"
    @mouseleave="scheduleTooltipHide"
  >
    <span class="error-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/triangle-exclamation-solid-full-red.svg')"
        alt="Icon"
      />
    </span>
    <Teleport to="body">
      <div v-if="visible" ref="popup" class="error-popup" :style="popupStyle"
        @mouseenter="cancelTooltipHide" @mouseleave="scheduleTooltipHide">
        {{ text }}
      </div>
    </Teleport>
  </div>
</template>

<script>
import floatingTooltip from '@/utils/floatingTooltip';

export default {
  mixins: [floatingTooltip],
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped src="@/styles/ErrorTooltip.css">

</style>
